import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Select, Store } from '@ngxs/store';
import { AcademicState, SetIpRange, StartAcademicVerification } from '@platform-frontend/checkout';
import { YATTA_SUPPORT_EMAIL_ADDRESS } from '@platform-frontend/platform';
import { InclusiveActionFilter } from '@platform-frontend/ui-tools';
import { Navigate } from '@platform-frontend/util';
import { Observable } from 'rxjs';
import { switchMap, take, tap } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'yat-ip-range',
  templateUrl: './ip-range.component.html',
  styleUrls: ['./ip-range.component.scss']
})
export class IpRangeComponent implements OnInit {
  constructor(private activatedRoute: ActivatedRoute, private store: Store, private fb: FormBuilder) {}

  readonly SUPPORT_EMAIL = 'mailto:' + YATTA_SUPPORT_EMAIL_ADDRESS;

  ipRangeForm = this.fb.group({
    ipAddresses: this.fb.array([this.fb.control('', { nonNullable: true, validators: Validators.required })])
  });

  startAcademicVerificationActionFilter = new InclusiveActionFilter(StartAcademicVerification);
  focused: number;

  @Select(AcademicState.ipRange)
  ipRange$: Observable<string[]>;

  ngOnInit(): void {
    this.ipRange$
      .pipe(
        take(1),
        tap(ipRange => this.createElement(ipRange)),
        untilDestroyed(this)
      )
      .subscribe();
  }

  submitForm(value: { ipAddresses: string[] }): void {
    this.store
      .dispatch(new SetIpRange(value.ipAddresses))
      .pipe(
        switchMap(() => this.store.dispatch(new StartAcademicVerification())),
        switchMap(() => this.store.dispatch(new Navigate(['../verify-academic-email'], { relativeTo: this.activatedRoute }))),
        untilDestroyed(this)
      )
      .subscribe();
  }

  goBack(): void {
    this.store
      .dispatch(new SetIpRange(this.ipRangeForm.get('ipAddresses')?.value ?? []))
      .pipe(
        switchMap(() => this.store.dispatch(new Navigate(['../verify-employee'], { relativeTo: this.activatedRoute }))),
        untilDestroyed(this)
      )
      .subscribe();
  }

  get ipAddresses(): FormArray<FormControl<string>> {
    return this.ipRangeForm.get('ipAddresses') as FormArray<FormControl<string>>;
  }

  addIpAddress(): void {
    this.ipAddresses.push(this.fb.control('', { nonNullable: true, validators: Validators.required }));
  }

  removeIpAddress(i: number): void {
    this.ipAddresses.removeAt(i);
  }

  createElement(ipRange: string[]): void {
    for (let i = 1; i < ipRange.length; i++) {
      this.addIpAddress();
    }
    this.ipRangeForm.patchValue({ ipAddresses: ipRange });
  }
}
